import './MissionVision.css';

// SVG icons — target (mission) and eye (vision)
const IconTarget = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);
const IconEye = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const cards = [
  {
    Icon: IconTarget,
    title: 'Our Mission',
    desc: 'To deliver innovative, affordable, and high-impact digital solutions that enable businesses of all sizes to compete and thrive in the modern marketplace. We are committed to making technology accessible and results measurable.',
    delay: 'd1',
  },
  {
    Icon: IconEye,
    title: 'Our Vision',
    desc: "To become one of India's most trusted digital partners, recognized for turning ambitious ideas into scalable digital realities. We envision a future where every business has the digital tools to succeed.",
    delay: 'd2',
  },
];

export default function MissionVision() {
  return (
    <section id="mission-vision" className="mv-section">
      <div className="mv-grid">
        {cards.map(c => (
          <div key={c.title} className={`mv-card reveal ${c.delay}`}>
            <span className="mv-icon"><c.Icon /></span>
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
